module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.visible,
      "append-to-body": "",
      "width": "70%"
    },
    on: {
      "open": _vm.initFromProps,
      "close": _vm.handleClose
    }
  }, [_c('div', _vm._l((_vm.submissionConfigs), function(config, index) {
    return _c('div', {
      key: config.value,
      style: ({
        marginBottom: '10px',
        marginTop: index > 0 ? '16px' : '0'
      })
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "10px",
        "font-weight": "bold"
      }
    }, [_vm._v("\n        " + _vm._s(config.label) + "\n      ")]), _vm._v(" "), _c('el-checkbox-group', {
      model: {
        value: (_vm.categoryLists[config.categoryListKey]),
        callback: function($$v) {
          _vm.$set(_vm.categoryLists, config.categoryListKey, $$v)
        },
        expression: "categoryLists[config.categoryListKey]"
      }
    }, _vm._l((_vm.categoryOptions), function(item) {
      return _c('el-checkbox', {
        key: item.value + '-' + config.value,
        attrs: {
          "label": item.value
        }
      }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])
    }), 1)], 1)
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00ef570c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/SubmissionCategoryDialog.vue
// module id = 2408
// module chunks = 68